var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckoutCloseSmall = function SvgCheckoutCloseSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.588 5.95-.513-.537L2.475 3 .075.563.588.025l2.425 2.438 2.4-2.438.512.538L3.525 3l2.4 2.413-.512.537-2.4-2.437L.588 5.95Z",
    fill: "#fff"
  })));
};
export default SvgCheckoutCloseSmall;